import { render } from "./QuotationDetail_client.vue?vue&type=template&id=37063fe6&scoped=true"
import script from "./QuotationDetail_client.vue?vue&type=script&lang=js"
export * from "./QuotationDetail_client.vue?vue&type=script&lang=js"

import "./QuotationDetail_client.vue?vue&type=style&index=0&id=37063fe6&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37063fe6"]])

export default __exports__